<template>
  <div class="dropzone"
       :class="{hover}">
    <input type="file"
           class="input file"
           ref="fileInput"
           data-drop-allowed="true"
           :accept="acceptedOrCustomTypes"
           @change="fileChanged"
           @dragenter="hover = true"
           @dragleave="hover = false"
           @drop="hover = false">

    <div class="facade">
      <slot />
      <br />
      <button class="button"
              @click="browse">
        <span class="icon fas fa-upload" />
        <span>{{ $t('browse') }}</span>
      </button>

      <slot name="after-button" />
    </div>
  </div>
</template>

<script>
import { postError } from '@/helpers/notification'

export default {
  name: 'DropZone',
  props: {
    /**
     * @prop accept
     * @values see fileTypes below
     * @usage separate multiple file types with comma;
     * accept="application/pdf,image/jpeg"
     */
    accept: {
      type: String,
      default: '*/*',
      validator: val => {
        // validators cannot read other props or 'this' scope
        const draftTypes = ['image/jpeg', 'image/gif', 'image/png', 'image/x-eps', 'image/tiff', 'image/svg+xml']
        const defaultTypes = ['application/pdf', 'image/jpeg', 'image/gif', 'image/png', 'image/x-eps', '*/*']
        let valid = true
        const providedFileTypes = val.split(',')
        let fileTypes

        if (providedFileTypes[0] === 'draft') {
          fileTypes = draftTypes
          providedFileTypes.shift()
        } else {
          fileTypes = defaultTypes
        }

        providedFileTypes.forEach(type => {
          if (!fileTypes.includes(type)) {
            valid = false
          }
        })
        return valid
      }
    },
    // Allows for custom override of default accepted file types
    customTypes: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      hover: false
    }
  },
  computed: {
    acceptedOrCustomTypes() {
      return !!this.customTypes.length ? this.customTypes : this.accept
    }
  },
  methods: {
    browse () {
      this.$refs.fileInput.click()
    },
    fileChanged (e) {
      const value = e.target.files[0] || null
      if((value.type && this.acceptedOrCustomTypes.includes(value.type)) || (value.type && this.acceptedOrCustomTypes === '*/*')) {
        this.$emit('change', value)
        this.$emit('input', value)
      } else {
        postError({
          title: this.$t('error'),
          text: this.$t('invalidFileType'),
        })
      }
      this.$refs.fileInput.value = ''
    }
  }
}
</script>

<style scoped lang="scss">
.dropzone {
  border: 0.1rem dotted #888;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .facade > * {
    margin: 0.25rem;
  }

  input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
  }

  &.hover {
    box-shadow: inset 0 0 1rem #888;
  }
}
</style>
